import { View, Text } from "@lightningtv/solid";
import { createSignal, onMount, onCleanup } from "solid-js";
import PinKeyboard from './PinKeyboard';
import PinKeyboardFast from "./PinKeyboardFast";

export default function ConfirmPin(props: {
    onPinSet: (pin?: string) => void;
    onPinFailed?: () => void;
    onEscape?: () => void;
    showBackground?: boolean;
    showText?: boolean;
    x?: number;
    y?: number;
    title?: string;
}) {
    const keyboardRef: any = {};
    const showBackground = props.showBackground !== false;

    const [isEnterEnabled, setIsEnterEnabled] = createSignal(false);
    const [clearInputs, setClearInputs] = createSignal(false); // ✅ NEW: Signal to trigger clearing

    let enableTimeout: number | null = null;

    onMount(() => {
        console.log('ConfirmPin opened - Enter key disabled for 1 second');

        enableTimeout = setTimeout(() => {
            setIsEnterEnabled(true);
            console.log('Enter key input now enabled');
        }, 1000);
    });

    onCleanup(() => {
        if (enableTimeout) {
            clearTimeout(enableTimeout);
        }
    });

    const handlePinSubmit = (pin: string) => {
        if (!isEnterEnabled()) {
            console.log('Enter key input not yet enabled - ignoring submission');
            return;
        }

        const savedPin = localStorage.getItem("userPin");
        console.log('pin', pin);
        console.log('savedPin', savedPin);

        if (pin === savedPin) {
            console.log('✅ PIN correct!');
            keyboardRef.resetInput?.();
            props.onPinSet(pin);
        } else {
            console.log('❌ PIN incorrect!');

            // ✅ Trigger clearing inputs via prop
            setClearInputs(true);

            // ✅ Reset the clearInputs signal after a short delay
            setTimeout(() => {
                setClearInputs(false);
            }, 100);

            // ✅ Also use the ref method as backup
            keyboardRef.resetInput?.();

            // ✅ Call onPinFailed if provided
            if (props.onPinFailed) {
                props.onPinFailed();
            }
        }
    };

    const KeyboardOnlyContent = () => (
        <View
            x={props.x || 0}
            y={props.y || 0}
            onEscape={() => {
                if (props.onEscape) {
                    props.onEscape();
                }
            }}
        >
            <Text x={190} y={0} fontSize={36}>
                {props.title || "Enter Parental PIN"}
            </Text>
            <Text
                x={190}
                y={50}
                fontSize={24}
                color={"#fff"}
            >
            </Text>
            <PinKeyboardFast
                onSubmit={handlePinSubmit}
                keyboardRef={keyboardRef}
                isEnterEnabled={isEnterEnabled()}
                clearInputs={clearInputs()} // ✅ NEW: Pass clearInputs signal
                onEnterAttempt={() => {
                    console.log('Enter attempted too early - please wait');
                }}
            />
        </View>
    );

    const FullScreenContent = () => (
        <View color={"#182027"}>
            <View src={"https://i.ibb.co/Lzk5hD4Y/Maskgroup.png"}>
                <View src="https://i.ibb.co/ZVmDwNg/logo.png" x={800} y={50} width={270} height={82} />

                <View x={50} y={50}>
                    <View src="https://i.ibb.co/LX13T2JW/Group-Live-Tv.png" width={102} height={102} />
                    <Text x={120} y={33} fontSize={34} fontWeight={"bold"}></Text>
                </View>

                <View x={610} y={200}>
                    <KeyboardOnlyContent />
                </View>
            </View>
        </View>
    );

    return showBackground ? <FullScreenContent /> : <KeyboardOnlyContent />;
}